export default function (state, val) {
    state.items = val.CurrencyBallance;
}